import { useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadFull } from 'tsparticles';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ISourceOptions } from '@tsparticles/engine';
import './App.css';
import particlesOptions from './particles.json';
import Contact from './components/SubscriptionForm';
import StartButton from './components/StartButton';
import Wheel from './components/Wheel';
import AlyfLogo from './assets/Alyf.svg';
import { CountdownProvider } from './context/CountdownContext';
import { DataContextProvider } from './context/DataContext';
import { AppConfigProvider, useAppConfig } from './context/AppConfigContext';
import { UserProvider } from './context/UserProvider';

const AppHeader: React.FC = () => {
  const { config } = useAppConfig();
  const logoSrc = config.logoUrl || AlyfLogo;

  return (
    <div className="absolute top-0 left-0 mt-4 ml-6 z-10">
      <img src={logoSrc} className="h-10" alt={config.brandName || 'Logo'} />
    </div>
  );
};

function App() {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => setInit(true));
  }, []);

  return (
    <AppConfigProvider>
      <UserProvider>
        <CountdownProvider>
          <DataContextProvider>
            <Router>
              <div className="App">
                <AppHeader />
                {init && <Particles options={particlesOptions as ISourceOptions} />}
                <Routes>
                  <Route path="/" element={<StartButton />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/wheel-of-fortune" element={<Wheel />} />
                </Routes>
              </div>
            </Router>
          </DataContextProvider>
        </CountdownProvider>
      </UserProvider>
    </AppConfigProvider>
  );
}

export default App;
